
/* styles */
require("!!../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-4e05434f&scoped=true!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./profileIntegrationCard.vue")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./profileIntegrationCard.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-4e05434f!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./profileIntegrationCard.vue"),
  /* scopeId */
  "data-v-4e05434f",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/features/profile/profileTabs/profileIntegrationCard.vue
// module id = 1625
// module chunks = 61